<ng-container *ngFor="let errorCode of errorCodes">
  <glxy-error
    *ngIf="
      control.hasError(errorCode) && validation.errorCodeMap[errorCode].severity === 'INVALID' && (showError$$ | async)
    "
  >
    {{
      validation.errorCodeMap[errorCode].message | translateByObjectType: objectType : { label: label.toLowerCase() }
    }}
  </glxy-error>
  <crm-uniqueness-suggestion-card
    [displayCard]="control.hasError(errorCode) && errorCode === 'uniqueness_enforced'"
    [objectType]="objectType"
    [fieldId]="fieldId"
    [label]="label"
    (displayError)="showError($event)"
  ></crm-uniqueness-suggestion-card>
</ng-container>
<glxy-hint *ngIf="warningCode$ | async as warningCode">
  <span *ngIf="control.status === 'VALID'">
    {{
      validation.errorCodeMap[warningCode].message | translateByObjectType: objectType : { label: label.toLowerCase() }
    }}
  </span>
</glxy-hint>
